import React from 'react';
import { PrimaryButton } from './styled/buttons';
import { Card } from './styled/card';
import { H1, P } from './styled/typography';

export const ErrorContent: React.FC<{}> = () => (
  <>
    <H1 color="#b5121b">Something went wrong, please try again</H1>
    <P color="#b5121b" style={{ paddingBottom: '12px', textAlign: 'center' }}>
      If you keep seeing this error please contact the helpdesk
    </P>
  </>
);

export const Error: React.FC<{ goBack?: () => void }> = ({ goBack }) => (
  <div
    style={{
      display: 'flex',
      flexDirection: 'column',
      margin: '0 auto',
      width: '40%',
    }}
  >
    <Card>
      <ErrorContent />
      <div
        style={{
          display: 'flex',
          flexDirection: 'row',
          justifyContent: 'flex-end',
        }}
      >
        <PrimaryButton
          style={{ flex: 'unset' }}
          onClick={() => window.location.reload()}
        >
          Reload
        </PrimaryButton>
        {goBack && (
          <PrimaryButton
            style={{ flex: 'unset', marginLeft: '8px' }}
            onClick={() => goBack()}
          >
            Go back
          </PrimaryButton>
        )}
      </div>
    </Card>
  </div>
);
